import React from 'react';
import {
  Alert,
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  Paper,
  Snackbar,
  TextField,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

export default function GuestRegistrationForm({ formData, setFormData }) {
  const [saved, setSaved] = useState(false);
  const visaIssueRef = React.useRef(null);
  const visaExpiryRef = React.useRef(null);
  const dobRef = React.useRef(null);
  const anniversaryRef = React.useRef(null);

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  return (
    <Box>
      <Box>
        <Typography variant="h6" gutterBottom>
          Guest details
        </Typography>

        {/* Top section */}
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <TextField
              label="Registration No."
              name="registrationNo"
              value={formData.registrationNo}
              // onChange={handleChange}
              fullWidth
              autoComplete="off"
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 5,
                },
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              label="Payment mode"
              name="paymentMode"
              value={formData.paymentMode}
              // onChange={handleChange}
              fullWidth
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 5,
                },
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              label="Guest name"
              name="guestName"
              value={formData.guestName}
              // onChange={handleChange}
              fullWidth
              required
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 5,
                },
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              label="Nationality"
              name="nationality"
              value={formData.nationality}
              onChange={handleChange}
              fullWidth
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 5,
                },
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              type="email"
              label="Email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              fullWidth
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 5,
                },
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              label="Phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              fullWidth
              inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 5,
                },
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              label="Source"
              name="source"
              value={formData.source}
              // onChange={handleChange}
              fullWidth
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 5,
                },
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              type="number"
              label="Booking amounts"
              name="bookingAmount"
              value={formData.bookingAmount}
              // onChange={handleChange}
              fullWidth
              inputProps={{ min: 0, step: '0.01' }}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 5,
                },
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="Address"
              name="address"
              value={formData.address}
              onChange={handleChange}
              fullWidth
              multiline
              minRows={2}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 5,
                },
              }}
            />
          </Grid>
        </Grid>

        <Divider sx={{ my: 3 }} />

        {/* Visa / Travel */}
        <Typography variant="subtitle1" gutterBottom>
          Visa / Travel
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <TextField
              label="Visa No."
              name="visaNumber"
              value={formData.visaNumber}
              onChange={handleChange}
              fullWidth
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 5,
                },
              }}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              inputRef={visaIssueRef}
              type="date"
              label="Visa Issue"
              name="visaIssueDate"
              value={formData.visaIssueDate}
              onChange={handleChange}
              fullWidth
              InputLabelProps={{ shrink: true }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      edge="end"
                      onClick={() =>
                        visaIssueRef.current?.showPicker?.() || visaIssueRef.current?.focus()
                      }
                      sx={{ color: '#fff' }} // white icon
                    >
                      <CalendarMonthIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 5,
                  position: 'relative',
                },

                '& .MuiOutlinedInput-input::-webkit-calendar-picker-indicator': {
                  opacity: 0,
                  display: 'none',
                },
              }}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              inputRef={visaExpiryRef}
              type="date"
              label="Visa Expiry"
              name="visaExpiryDate"
              value={formData.visaExpiryDate}
              onChange={handleChange}
              fullWidth
              InputLabelProps={{ shrink: true }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      edge="end"
                      onClick={() =>
                        visaExpiryRef.current?.showPicker?.() || visaExpiryRef.current?.focus()
                      }
                      sx={{ color: '#fff' }} // white icon
                    >
                      <CalendarMonthIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 5,
                  position: 'relative',
                },

                '& .MuiOutlinedInput-input::-webkit-calendar-picker-indicator': {
                  opacity: 0,
                  display: 'none',
                },
              }}
            />
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField
              inputRef={dobRef}
              type="date"
              label="DOB"
              name="dob"
              value={formData.dob}
              onChange={handleChange}
              fullWidth
              InputLabelProps={{ shrink: true }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      edge="end"
                      onClick={() => dobRef.current?.showPicker?.() || dobRef.current?.focus()}
                      sx={{ color: '#fff' }} // white icon
                    >
                      <CalendarMonthIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 5,
                  position: 'relative',
                },

                '& .MuiOutlinedInput-input::-webkit-calendar-picker-indicator': {
                  opacity: 0,
                  display: 'none',
                },
              }}
            />
          </Grid>
          <Grid item xs={12} md={9}>
            <TextField
              label="Purpose of visit"
              name="purposeOfVisit"
              value={formData.purposeOfVisit}
              onChange={handleChange}
              fullWidth
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 5,
                },
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              label="Arrived from"
              name="arrivedFrom"
              value={formData.arrivedFrom}
              onChange={handleChange}
              fullWidth
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 5,
                },
              }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label="Preferences"
              name="preferences"
              value={formData.preferences}
              onChange={handleChange}
              fullWidth
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 5,
                },
              }}
            />
          </Grid>
        </Grid>

        <Divider sx={{ my: 3 }} />

        {/* Company */}
        <Typography variant="subtitle1" gutterBottom>
          Company details
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <TextField
              label="Company name"
              name="companyName"
              value={formData.companyName}
              onChange={handleChange}
              fullWidth
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 5,
                },
              }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label="Company GST"
              name="companyGST"
              value={formData.companyGST}
              onChange={handleChange}
              fullWidth
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 5,
                },
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              label="Designation"
              name="designation"
              value={formData.designation}
              onChange={handleChange}
              fullWidth
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 5,
                },
              }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label="Company contact"
              name="companyContact"
              value={formData.companyContact}
              onChange={handleChange}
              fullWidth
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 5,
                },
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="Company address"
              name="companyAddress"
              value={formData.companyAddress}
              onChange={handleChange}
              fullWidth
              multiline
              minRows={2}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 5,
                },
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              type="email"
              label="Company email"
              name="companyEmail"
              value={formData.companyEmail}
              onChange={handleChange}
              fullWidth
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 5,
                },
              }}
            />
          </Grid>
        </Grid>

        <Divider sx={{ my: 3 }} />

        {/* Other */}
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <TextField
              label="Vehicle No."
              name="vehicleNo"
              value={formData.vehicleNo}
              onChange={handleChange}
              fullWidth
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 5,
                },
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              inputRef={anniversaryRef}
              type="date"
              label="Anniversary"
              name="anniversary"
              value={formData.anniversary}
              onChange={handleChange}
              fullWidth
              InputLabelProps={{ shrink: true }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      edge="end"
                      onClick={() =>
                        anniversaryRef.current?.showPicker?.() || anniversaryRef.current?.focus()
                      }
                      sx={{ color: '#fff' }} // white icon
                    >
                      <CalendarMonthIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 5,
                  position: 'relative',
                },

                '& .MuiOutlinedInput-input::-webkit-calendar-picker-indicator': {
                  opacity: 0,
                  display: 'none',
                },
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="Remark"
              name="remark"
              value={formData.remark}
              onChange={handleChange}
              fullWidth
              multiline
              minRows={3}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 5,
                },
              }}
            />
          </Grid>
        </Grid>

        {/* <Box sx={{ mt: 3, display: "flex", gap: 2 }}>
          <Button variant="contained" onClick={handleSubmit}>
            Save
          </Button>
          <Button variant="outlined" onClick={handleReset}>
            Reset
          </Button>
        </Box> */}
      </Box>

      {/* <Snackbar
        open={saved}
        autoHideDuration={2500}
        onClose={() => setSaved(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          severity="success"
          onClose={() => setSaved(false)}
          sx={{ width: "100%" }}
        >
          Form saved (check console for payload)!
        </Alert>
      </Snackbar> */}
    </Box>
  );
}
